import {Link, RunInAction, RunInAction_Set, TextPlus} from "web-vcore";
import moment from "moment";
import {Button, CheckBox, Column, Div, Grid, Row, Select, Spinner, Text, TextInput} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {AddJournalEntry} from "../../Server/Commands/JournalEntryCommands.js";
import {GetJournalEntryAllText, GetWordsInDreamEntry_Map, GetWordsInDreamSegment_Map, JournalEntry, JournalSegment} from "../../Server/DB/journalEntries/@JournalEntry.js";
import {Me} from "../../Server/DB/users.js";
import {store} from "../../Store/index.js";
import {ES} from "web-vcore";
import {ShowSignInPopup} from "../@Shared/NavBar/UserPanel.js";
import {BaseComponent} from "react-vextensions";
import {JournalDisplayMode, JournalSort} from "../../Store/main/journal.js";
import {GetEntries} from "js-vextensions";
import React, {useState} from "react";
import {observer} from "mobx-react";
import {E, StartDownload} from "js-vextensions";
import {EntryListSettingsDropdown} from "./EntryList/EntryListSettingsDropdown.js";
import {DoesSegmentMatchFilter, JournalEntryPreview} from "./JournalEntryPreview.js";
import {GetDreamEvents} from "../../Server/DB/journalEntries.js";
import {observer_mgl} from "mobx-graphlink";
import {GetWordsInText_Array_Deduped} from "../../Utils/Search/StringToWords.js";
import {MergeSets} from "../../Utils/General/General.js";
import {DreamPreview} from "./DreamList/DreamPreview.js";
import {JournalSegmentUI} from "./JournalEntry/SegmentUI.js";
import {SpinnerForPercent} from "../../Utils/ReactComponents/SpinnerForPercent.js";
import {JournalDisplayModeSwitcher} from "./JournalUI.js";
import {CombineEntryAndSegment, EntryAndSegment} from "../../Server/DB/journalEntries/$journalEntry.js";
import {EstimateSegmentStartTime} from "../../Server/DB/@Shared/JournalTimeEstimates.js";

export const GetDreamsToShow_EntryList = (entries: JournalEntry[], sort: JournalSort, sort_desc: boolean, onlyLucids: boolean, onlyIntegratable: boolean, onlyNonEmpty: boolean): EntryAndSegment[]=>{
	const dreams = entries.flatMap(a=>a.segments.map(b=>CombineEntryAndSegment(a, b))).filter(a=>a.segment.wakeTime == null);
	return dreams
		.filter(dream=>{
			if (onlyLucids && !dream.segment.lucid) return false;
			if (onlyIntegratable && dream.segment.excludeFromIntegration) return false;
			if (onlyNonEmpty && dream.segment.longText.trim().length == 0) return false;
			return true;
		})[sort_desc ? "OrderByDescending" : "OrderBy"](dream=>{
			//const entry = entries.find(a=>a.segments.includes(dream))!;
			if (sort == JournalSort.date) return EstimateSegmentStartTime(dream.entry, dream.segment);
			if (sort == JournalSort.longText_length) return dream.segment.longText.length;
		});
};

export const DreamList = observer_mgl((props: {entries: JournalEntry[]})=>{
	const {entries} = props;
	const uiState1 = store.main.journal;
	const uiState2 = store.main.engine.journey;

	const dreamsToShow = GetDreamsToShow_EntryList(entries, uiState1.sortBy, uiState1.sort_desc, uiState1.dreamList_onlyLucids, uiState1.dreamList_onlyIntegratable, true);
	const selectedDream_journalEntry = uiState1.dreamList_selectedDream ? entries.find(a=>a.segments.Any(b=>b.id == uiState1.dreamList_selectedDream)) : null;
	const selectedDream = selectedDream_journalEntry ? selectedDream_journalEntry.segments.find(a=>a.id == uiState1.dreamList_selectedDream) : null;

	return (
		<Column style={ES({height: "100%", flex: 30})}>
			<Row className="clickThrough" style={{flexWrap: "wrap", gap: 5, padding: 10, background: "rgba(0,0,0,.7)", borderRadius: "10px 10px 0 0"}}>
				<JournalDisplayModeSwitcher/>
				<CheckBox text="Only lucids" value={uiState1.dreamList_onlyLucids} onChange={val=>RunInAction_Set(()=>uiState1.dreamList_onlyLucids = val)}/>
				<CheckBox text="Only integratable" value={uiState1.dreamList_onlyIntegratable} onChange={val=>RunInAction_Set(()=>uiState1.dreamList_onlyIntegratable = val)}/>
				<Row>
					<Text>Sort:</Text>
					<Select ml={5} options={GetEntries(JournalSort, "ui")} value={uiState1.sortBy} onChange={val=>RunInAction_Set(()=>uiState1.sortBy = val)}/>
					<Button ml={5} mdIcon={uiState1.sort_desc ? "arrow-down" : "arrow-up"} onClick={()=>{
						RunInAction_Set(()=>uiState1.sort_desc = !uiState1.sort_desc);
					}}/>
				</Row>
				<CheckBox text="Side-panel" value={uiState1.dreamList_sidePanel_show} onChange={val=>RunInAction_Set(()=>uiState1.dreamList_sidePanel_show = val)}/>
				<Text ml={5}>Size:</Text>
				<SpinnerForPercent ml={5} value={uiState1.dreamList_sidePanel_size} onChange={val=>RunInAction_Set(()=>uiState1.dreamList_sidePanel_size = val)}/>
			</Row>
			<Row style={{flex: 1, minHeight: 0}}>
				<ScrollView style={{flex: (1 - uiState1.dreamList_sidePanel_size).ToPercent()}} contentStyle={E(
					{
						borderRadius: "0 0 10px 10px",
						//backgroundColor: "rgba(30,30,30,.7)",
						backgroundColor: "rgba(0,0,0,1)",
						display: "flex", flexWrap: "wrap", gap: "0 5px",
					},
					uiState1.textPreviewMultiline && {minWidth: null},
				)} content_onClick={e=>{
					if (e.target != e.currentTarget) return;
					RunInAction("DreamList.background.onClick", ()=>store.main.journal.dreamList_selectedDream = null);
				}}>
					{dreamsToShow.length == 0 && <div style={{textAlign: "center", fontSize: 18}}>No matching dreams.</div>}
					{dreamsToShow.map((dream, index)=>{
						const entry = entries.find(a=>a.segments.includes(dream.segment))!;
						return <DreamPreview key={dream.segment.id ?? index} journalEntry={entry} dream={dream.segment}/>;
					})}
				</ScrollView>
				{uiState1.dreamList_sidePanel_show &&
				<ScrollView style={{flex: uiState1.dreamList_sidePanel_size.ToPercent()}}>
					{selectedDream != null && selectedDream_journalEntry != null && <>
						<JournalSegmentUI
							key={selectedDream.id ?? selectedDream_journalEntry.id} // ensure fresh comp per dream (prevent failed-text-load/text-overwrite)
							entry={selectedDream_journalEntry} segment={selectedDream} segments={selectedDream_journalEntry.segments}
							showActionsRow={false} showStartTime={true}/>
						<Link actionFunc={s=>{
							s.main.journal.selectedJournalEntry = selectedDream_journalEntry?.id;
						}}>
							<Button text="Show full journal-entry"/>
						</Link>
					</>}
				</ScrollView>}
			</Row>
		</Column>
	);
});